import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import logo from '../../../images/logo.png'
import barion from '../../../images/barion.jpg'
import {Link} from 'react-router-dom'

class Footer extends Reflux.Component {

    constructor() {
        super()
        this.state = {}
        this.store = Store
    }

    render() {
        return (
            <section id="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2">
                            <img className='footer-logo img-fluid' src={logo} title="logo" alt="logo"/>
                        </div>
                        <div className="col-md-10">
                            <ul className='footer-links'>
                                <li>
                                    <Link to="/terms-and-conditions">Felhasználási feltételek</Link>
                                </li>
                                <li>
                                    <Link to="/privacy-policy">Adatvédelmi irányelvek</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <a href='https://www.barion.com/hu/tajekoztato-biztonsagos-online-fizetesrol' target='_blank'>
                                <img style={{maxWidth: 350}} src={barion} className="pull-right"
                                     alt="A szolgáltatást nyújtó Barion Payment Zrt a Magyar Nemzeti Bank felügyelete alatt álló intézmény, engedélyének száma: H-EN-I-1064/2013."
                                     title='A szolgáltatást nyújtó Barion Payment Zrt a Magyar Nemzeti Bank felügyelete alatt álló intézmény, engedélyének száma: H-EN-I-1064/2013.'/>
                            </a>
                            <p className='footer-copyright-text'>&copy; beeker - All Rights reserved. </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/common/footer/footer.js